import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './producaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import CargaForm from '../carga/cargaForm';

import {
	setModoTela,
	setFiltro,
	initForm,
	salvar,
	alterarOrdem,
	excluir,
	fecharDia,
	getLista,
	getListaSolicitacoes
} from './producaoActions';

import {
	getLista as getListaParceiro
} from '../parceiro/parceiroActions';

import {
	getLista as getListaRacao
} from '../racao/racaoActions';

import {
	getLista as getListaUnidadeMedida
} from '../unidadeMedida/unidadeMedidaActions';

import {
	getLista as getListaEquipamento
} from '../equipamento/equipamentoActions';

import {
	getLista as getListaVeiculo
} from '../veiculo/veiculoActions';

import {
	getLista as getListaMotorista
} from '../motorista/motoristaActions';

import {
	initForm as initCargaForm,
	salvar as salvarCarga,
	getLista as getListaCargas,
	getListaProducoes as getListaProducoesCarga
} from '../carga/cargaActions';


const columns = [
	{
		field: 'ordem',
		type: 'int'
	},
	{
		field: 'id',
		type: 'int'
	},
	{
		field: 'id_solicitacao',
		type: 'int'
	},
	{
		field: 'data_agendamento',
		type: 'date'
	},
	{
		field: 'nome_parceiro',
		type: 'text'
	},
	{
		field: 'nome_racao',
		type: 'text'
	},
	{
		field: 'quantidade',
		type: 'decimal'
	},
	{
		field: 'sigla_unidade_medida',
		type: 'text'
	}
];


class Producao extends Component {

	state = {
		linhaSelecionada: null,
		cargaAberta: false,

		sort: {
			field: 'ordem',
			direction: 'asc'
		}
	}


	componentDidMount() {

	}


	componentWillMount() {

		this.props.getLista();
		this.props.getListaSolicitacoes();
		this.props.getListaParceiro();
		this.props.getListaRacao();
		this.props.getListaUnidadeMedida();
		this.props.getListaEquipamento();
		this.props.getListaVeiculo();
		this.props.getListaMotorista();
		this.props.getListaCargas();
	}


	render() {

		return (
			<div>
				<Content>

					<Aguardando
						aguardando={
							this.props.aguardando ||
							this.props.aguardandoCarga
						}
					/>

					{this.state.cargaAberta ? (

						<CargaForm
							permitirAlterarProducoes
							onSubmit={registro =>
								this.props.salvarCarga(
									registro,
									() => {

										this.setState({
											cargaAberta: false
										});

										this.props.getLista();
										this.props.getListaCargas();
									}
								)
							}
							onVoltar={() =>
								this.setState({
									cargaAberta: false
								})
							}
						/>

					) : this.props.modoTela == 'cadastro' ? (

						<Form
							onSubmit={this.props.salvar}
						/>

					) : null}


					{!this.state.cargaAberta &&
						this.props.modoTela == 'exclusao' ? (

						<Form
							excluir
							onSubmit={this.props.excluir}
						/>

					) : null}


					{!this.state.cargaAberta &&
						this.props.modoTela == 'lista'
						? this.lista()
						: null
					}

				</Content>
			</div>
		);
	}


	cargaDaProducao(idProducao) {

		return (
			this.props.listaCargas || []
		).find(carga =>
			(carga.producoes || []).some(
				producao =>
					String(producao.id_producao) ===
					String(idProducao)
			)
		);
	}


	producaoTemCarga(item) {

		return !!(
			item &&
			this.cargaDaProducao(item.id)
		);
	}


	abrirCarga(item) {

		const carga =
			this.cargaDaProducao(item.id);


		const registro =
			carga
				? {
					...carga,

					producoes:
						(carga.producoes || []).map(
							producao => ({
								id_producao:
									producao.id_producao,

								ordem:
									producao.ordem
							})
						)
				}
				: {
					data_agendamento:
						item.data_agendamento,

					producoes: [
						{
							id_producao:
								item.id,

							ordem:
								item.ordem
						}
					]
				};


		this.props.initCargaForm(
			registro
		);

		this.props.getListaProducoesCarga(
			item.data_agendamento
		);

		this.setState({
			cargaAberta: true
		});
	}


	renderCarga(item) {

		const carga =
			this.cargaDaProducao(item.id);


		if (!carga) {

			return (
				<span
					style={{
						color: '#999'
					}}
				>
					Sem carga
				</span>
			);
		}


		return (
			<div>

				<div>
					<strong>
						Carga {carga.id}
					</strong>

					{' - '}

					{carga.placa_veiculo}
				</div>


				<div
					style={{
						fontSize: 10
					}}
				>
					{carga.nome_motorista}
				</div>

			</div>
		);
	}


	dadosGrupoCarga(lista, indice) {

		const carga =
			this.cargaDaProducao(
				lista[indice].id
			);


		if (!carga) {

			return {
				carga: null,
				inicio: false,
				fim: false,
				tamanho: 1
			};
		}


		const cargaAnterior =
			indice > 0
				? this.cargaDaProducao(
					lista[indice - 1].id
				)
				: null;


		const cargaSeguinte =
			indice < lista.length - 1
				? this.cargaDaProducao(
					lista[indice + 1].id
				)
				: null;


		const inicio =
			!cargaAnterior ||
			String(cargaAnterior.id) !==
				String(carga.id);


		const fim =
			!cargaSeguinte ||
			String(cargaSeguinte.id) !==
				String(carga.id);


		let tamanho = 1;


		if (inicio) {

			for (
				let posicao = indice + 1;
				posicao < lista.length;
				posicao++
			) {

				const cargaPosicao =
					this.cargaDaProducao(
						lista[posicao].id
					);


				if (
					!cargaPosicao ||
					String(cargaPosicao.id) !==
						String(carga.id)
				) {
					break;
				}

				tamanho++;
			}
		}


		return {
			carga,
			inicio,
			fim,
			tamanho
		};
	}


	getIdCargaProducao = item => {

		if (!item) {
			return null;
		}

		const carga =
			this.cargaDaProducao(
				item.id
			);

		return carga
			? carga.id
			: null;
	}


	getBlocoProducao = (
		lista,
		indice
	) => {

		const item =
			lista[indice];

		const idCarga =
			this.getIdCargaProducao(
				item
			);


		/*
		 * Produção sem carga:
		 * ela própria é um bloco.
		 */
		if (!idCarga) {

			return {
				inicio: indice,
				fim: indice,
				itens: [item],
				idCarga: null
			};
		}


		let inicio =
			indice;

		let fim =
			indice;


		/*
		 * Procura o início do bloco.
		 */
		while (inicio > 0) {

			const idCargaAnterior =
				this.getIdCargaProducao(
					lista[inicio - 1]
				);


			if (
				String(idCargaAnterior) !=
				String(idCarga)
			) {
				break;
			}

			inicio--;
		}


		/*
		 * Procura o fim do bloco.
		 */
		while (
			fim <
			lista.length - 1
		) {

			const idCargaSeguinte =
				this.getIdCargaProducao(
					lista[fim + 1]
				);


			if (
				String(idCargaSeguinte) !=
				String(idCarga)
			) {
				break;
			}

			fim++;
		}


		return {
			inicio,
			fim,

			itens:
				lista.slice(
					inicio,
					fim + 1
				),

			idCarga
		};
	}


	moverProducao = (
		lista,
		indice,
		direcao
	) => {

		if (
			!lista ||
			!lista.length
		) {
			return;
		}


		const item =
			lista[indice];


		if (!item) {
			return;
		}


		const idCarga =
			this.getIdCargaProducao(
				item
			);


		/*
		 * =========================================================
		 * ITEM COM CARGA
		 * =========================================================
		 */
		if (idCarga) {

			const bloco =
				this.getBlocoProducao(
					lista,
					indice
				);


			/*
			 * -----------------------------------------------------
			 * SUBIR
			 * -----------------------------------------------------
			 */
			if (
				direcao == 'cima'
			) {

				if (indice <= 0) {
					return;
				}


				/*
				 * Se não é o primeiro do bloco,
				 * troca apenas com o item anterior
				 * da mesma carga.
				 */
				if (
					indice >
					bloco.inicio
				) {

					const itemAcima =
						lista[indice - 1];


					this.props.alterarOrdem([
						{
							...itemAcima,
							ordem:
								item.ordem
						},
						{
							...item,
							ordem:
								itemAcima.ordem
						}
					]);

					return;
				}


				/*
				 * É o primeiro item da carga.
				 * Move o bloco inteiro para cima.
				 */
				const indiceOutroBloco =
					bloco.inicio - 1;


				if (
					indiceOutroBloco < 0
				) {
					return;
				}


				const outroBloco =
					this.getBlocoProducao(
						lista,
						indiceOutroBloco
					);


				const itensOriginais = [
					...outroBloco.itens,
					...bloco.itens
				];


				const ordens =
					itensOriginais
						.map(itemAux =>
							Number(
								itemAux.ordem
							)
						)
						.sort(
							(a, b) =>
								a - b
						);


				const novaSequencia = [
					...bloco.itens,
					...outroBloco.itens
				];


				const registrosAlterar =
					novaSequencia.map(
						(itemAux, posicao) => ({
							...itemAux,

							ordem:
								ordens[posicao]
						})
					);


				this.props.alterarOrdem(
					registrosAlterar
				);

				return;
			}


			/*
			 * -----------------------------------------------------
			 * DESCER
			 * -----------------------------------------------------
			 */
			if (
				direcao == 'baixo'
			) {

				if (
					indice >=
					lista.length - 1
				) {
					return;
				}


				/*
				 * Se não é o último do bloco,
				 * troca somente com o próximo
				 * item da mesma carga.
				 */
				if (
					indice <
					bloco.fim
				) {

					const itemAbaixo =
						lista[indice + 1];


					this.props.alterarOrdem([
						{
							...itemAbaixo,

							ordem:
								item.ordem
						},
						{
							...item,

							ordem:
								itemAbaixo.ordem
						}
					]);

					return;
				}


				/*
				 * É o último item da carga.
				 * Move o bloco inteiro para baixo.
				 */
				const indiceOutroBloco =
					bloco.fim + 1;


				if (
					indiceOutroBloco >=
					lista.length
				) {
					return;
				}


				const outroBloco =
					this.getBlocoProducao(
						lista,
						indiceOutroBloco
					);


				const itensOriginais = [
					...bloco.itens,
					...outroBloco.itens
				];


				const ordens =
					itensOriginais
						.map(itemAux =>
							Number(
								itemAux.ordem
							)
						)
						.sort(
							(a, b) =>
								a - b
						);


				const novaSequencia = [
					...outroBloco.itens,
					...bloco.itens
				];


				const registrosAlterar =
					novaSequencia.map(
						(itemAux, posicao) => ({
							...itemAux,

							ordem:
								ordens[posicao]
						})
					);


				this.props.alterarOrdem(
					registrosAlterar
				);

				return;
			}
		}


		/*
		 * =========================================================
		 * ITEM SEM CARGA
		 * =========================================================
		 *
		 * Se o vizinho possui carga, move em relação ao bloco
		 * inteiro.
		 *
		 * Se o vizinho também não possui carga, apenas troca.
		 */


		if (
			direcao == 'cima'
		) {

			if (indice <= 0) {
				return;
			}


			const itemAcima =
				lista[indice - 1];

			const idCargaAcima =
				this.getIdCargaProducao(
					itemAcima
				);


			/*
			 * Vizinho sem carga:
			 * troca simples.
			 */
			if (!idCargaAcima) {

				this.props.alterarOrdem([
					{
						...itemAcima,

						ordem:
							item.ordem
					},
					{
						...item,

						ordem:
							itemAcima.ordem
					}
				]);

				return;
			}


			/*
			 * Vizinho é uma carga:
			 * move o item antes do bloco inteiro.
			 */
			const blocoAcima =
				this.getBlocoProducao(
					lista,
					indice - 1
				);


			const itensOriginais = [
				...blocoAcima.itens,
				item
			];


			const ordens =
				itensOriginais
					.map(itemAux =>
						Number(
							itemAux.ordem
						)
					)
					.sort(
						(a, b) =>
							a - b
					);


			const novaSequencia = [
				item,
				...blocoAcima.itens
			];


			const registrosAlterar =
				novaSequencia.map(
					(itemAux, posicao) => ({
						...itemAux,

						ordem:
							ordens[posicao]
					})
				);


			this.props.alterarOrdem(
				registrosAlterar
			);

			return;
		}


		if (
			direcao == 'baixo'
		) {

			if (
				indice >=
				lista.length - 1
			) {
				return;
			}


			const itemAbaixo =
				lista[indice + 1];

			const idCargaAbaixo =
				this.getIdCargaProducao(
					itemAbaixo
				);


			/*
			 * Vizinho sem carga:
			 * troca simples.
			 */
			if (!idCargaAbaixo) {

				this.props.alterarOrdem([
					{
						...itemAbaixo,

						ordem:
							item.ordem
					},
					{
						...item,

						ordem:
							itemAbaixo.ordem
					}
				]);

				return;
			}


			/*
			 * Vizinho é uma carga:
			 * move o item depois do bloco inteiro.
			 */
			const blocoAbaixo =
				this.getBlocoProducao(
					lista,
					indice + 1
				);


			const itensOriginais = [
				item,
				...blocoAbaixo.itens
			];


			const ordens =
				itensOriginais
					.map(itemAux =>
						Number(
							itemAux.ordem
						)
					)
					.sort(
						(a, b) =>
							a - b
					);


			const novaSequencia = [
				...blocoAbaixo.itens,
				item
			];


			const registrosAlterar =
				novaSequencia.map(
					(itemAux, posicao) => ({
						...itemAux,

						ordem:
							ordens[posicao]
					})
				);


			this.props.alterarOrdem(
				registrosAlterar
			);
		}
	}


	filtrar() {

		const listaFiltrada =
			this.props.lista
				.filter(item => {

					return !(
						this.state.pesquisar || ''
					).trim()
						||
						(
							this.state.pesquisar
								.toUpperCase() || ''
						)
							.split('+')
							.filter(p =>
								p.trim()
							)
							.every(
								pesquisar => `
									${item.id}
									${item.id_solicitacao}
									${DateFormat.formatarDataSqlParaTela(item.data_agendamento)}
									${item.nome_parceiro}
									${item.nome_racao}
									${FormatUtils.formatarValorTela(item.quantidade, 2)}
									${item.sigla_unidade_medida}
								`
									.toUpperCase()
									.includes(
										pesquisar
									)
							);
				})
				.map(item => ({
					...item,

					quantidade:
						FormatUtils
							.formatarValorTela(
								item.quantidade,
								2
							)
				}));


		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}


	onSort(field) {

		this.setState(prev => {

			let direction =
				'asc';


			if (
				prev.sort.field === field
			) {

				direction =
					prev.sort.direction === 'asc'
						? 'desc'
						: 'asc';
			}


			return {
				sort: {
					field,
					direction
				}
			};
		});
	}


	lista() {

		const ExcelFile =
			ReactExport.ExcelFile;


		const listaAux =
			this.filtrar();


		let lista = [];

		listaAux.forEach(item => {
			lista.push(item);
		});


		let setLinhaSelecionada =
			id => {

				this.setState({
					...this.state,

					linhaSelecionada:
						id
				});
			};


		return (
			<ContentCard>

				<ContentCardHeader>

					<Row>

						<LabelAndInputDate
							label='Data'
							cols='12 1 1 1'
							value={
								this.props.filtro.data
							}
							onChange={value => {

								this.props.setFiltro({
									...this.props.filtro,

									data:
										value
								});
							}}
						/>


						<div
							style={{
								marginTop: 8,
								width: 320
							}}
						>

							<a
								className='btn btn-app bg-primary'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {

									this.props.getLista();

									this.props
										.getListaSolicitacoes();

									this.props
										.getListaCargas();
								}}
							>
								<i className='fas fa-sync-alt'></i>
								{' '}
								Atualizar
							</a>


							<a
								className='btn btn-app bg-success'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {

									this.props
										.getListaSolicitacoes();

									this.props
										.setModoTela(
											'cadastro',
											{}
										);

									this.props
										.initForm({
											itens: [],

											id_equipamento:
												this.props
													.listaEquipamento
													.length == 1
													? this.props
														.listaEquipamento[0]
														.id
													: null
										});
								}}
							>
								<i className='fas fa-plus'></i>
								{' '}
								Adicionar
							</a>


							<ExcelFile
								filename={'Producões'}
								element={
									<a
										className='btn btn-app bg-success'
										style={{
											marginLeft: 2,
											minWidth: 75
										}}
									>
										<i className='fas fa-file-excel'></i>
										{' '}
										Exportar
									</a>
								}
							>
								{this.montarExcel(
									lista
								)}
							</ExcelFile>


							<a
								className='btn btn-app bg-success'
								style={{
									marginLeft: 2,
									minWidth: 75
								}}
								onClick={() => {

									this.props.fecharDia(
										this.props.lista
									);
								}}
							>
								<i className='fas fa-check'></i>
								{' '}
								Fechar Dia
							</a>

						</div>

					</Row>

				</ContentCardHeader>


				<ContentCardBody>

					<Table
						responsive
						border
						alturaFixa
						striped
						maxHeight={
							window.innerWidth < 631
								? window.innerHeight - 260
								: window.innerHeight - 180
						}
					>

						<THead>
							<Tr>

								<ThSort
									field='ordem'
									label='Ordem'
									width={100}
								/>

								<ThSort
									field='id'
									label='Número'
									width={10}
								/>

								<ThSort
									field='id_solicitacao'
									label='Solicitação'
									width={10}
								/>

								<ThSort
									field='data_agendamento'
									label='Agendamento'
									width={10}
								/>

								<ThSort
									field='nome_parceiro'
									label='Parceiro'
									width={200}
								/>

								<ThSort
									field='silo_lote'
									label='Silo / Lote'
									width={100}
								/>

								<ThSort
									field='nome_racao'
									label='Ração'
									width={200}
								/>

								<ThSort
									field='quantidade'
									label='Quantidade'
									width={80}
								/>

								<ThSort
									field='carga'
									label='Carga'
									width={200}
								/>

								<Th
									sticky
									alignCenter
									width={50}
								/>

							</Tr>
						</THead>


						<TBody>

							{lista.map((item, i) => {

								const grupoCarga =
									this.dadosGrupoCarga(
										lista,
										i
									);


								const bordaGrupo =
									grupoCarga.carga
										? {
											borderTop:
												grupoCarga.inicio
													? '4px solid #17a2b8'
													: undefined,

											borderBottom:
												grupoCarga.fim
													? '4px solid #17a2b8'
													: undefined
										}
										: {};


								return (
									<Tr
										key={i}
										style={bordaGrupo}

										backgroundColor={
											this.state.linhaSelecionada ==
												item.id
												? '#bcc7eb'
												: (
													grupoCarga.carga
														? '#eef8fa'
														: (
															i % 2 == 0
																? '#ffffff'
																: '#f5f5f5'
														)
												)
										}
									>

										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>

											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'center',
													alignItems: 'center'
												}}
											>

												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														justifyContent: 'center',
														alignItems: 'center',
														paddingLeft: 8,
														paddingRight: 8,
														width: 32,
														height: 32,
														fontWeight: 'bold',
														backgroundColor: '#6c757d',
														color: '#ffffff',
														borderRadius: '50%'
													}}
												>
													{item.ordem}
												</div>


												<div
													style={{
														width: 40
													}}
												>

													<ButtonTable
														type='secondary'
														width={32}
														small
														icon='fas fa-angle-up'
														visible={true}
														disabled={i == 0}
														event={() => {

															this.moverProducao(
																lista,
																i,
																'cima'
															);
														}}
													/>


													<ButtonTable
														type='secondary'
														width={32}
														small
														icon='fas fa-angle-down'
														visible={true}
														disabled={
															lista.length ==
															(i + 1)
														}
														event={() => {

															this.moverProducao(
																lista,
																i,
																'baixo'
															);
														}}
													/>

												</div>

											</div>

										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{item.id}
										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{item.id_solicitacao}
										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{DateFormat
												.formatarDataSqlParaTela(
													item.data_agendamento
												)}
										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{item.nome_parceiro}
										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{item.silo_lote}
										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{item.nome_racao}
										</Td>


										<Td
											onClick={() =>
												setLinhaSelecionada(
													item.id
												)
											}
											alignCenter
										>
											{item.quantidade}
											{' '}
											{item.sigla_unidade_medida}
										</Td>


										{!grupoCarga.carga &&
											<Td
												onClick={() =>
													setLinhaSelecionada(
														item.id
													)
												}
												alignCenter
											>
												{this.renderCarga(
													item
												)}
											</Td>
										}


										{grupoCarga.carga &&
											grupoCarga.inicio &&

											<Td
												rowSpan={
													grupoCarga.tamanho
												}
												alignCenter
												backgroundColor='#d9f1f5'
												style={{
													borderLeft:
														'4px solid #17a2b8',

													borderRight:
														'2px solid #17a2b8'
												}}
											>
												{this.renderCarga(
													item
												)}
											</Td>
										}


										<Td
											alignCenter
											minWidth={130}
											maxWidth={130}
										>

											<ButtonTable
												type='info'
												width={32}
												small
												icon='fas fa-truck-loading'
												visible={
													this.props.getPermissao(
														'cargas',
														[
															this.cargaDaProducao(
																item.id
															)
																? 'ALTERACAO'
																: 'INCLUSAO'
														]
													)
												}
												title={
													this.cargaDaProducao(
														item.id
													)
														? 'Editar carga'
														: 'Montar carga'
												}
												event={() =>
													this.abrirCarga(
														item
													)
												}
											/>


											<ButtonTable
												type='warning'
												width={32}
												small
												icon='fas fa-pencil-alt'
												visible={true}
												title='Editar'
												event={() => {

													this.props.setModoTela(
														'cadastro',
														{
															...item
														}
													);

													this.props.initForm({
														...item
													});
												}}
											/>


											<ButtonTable
												type='danger'
												width={32}
												small
												icon='fas fa-trash-alt'
												visible={
													!item.datahora_inicio
												}
												title='Excluir'
												event={() => {

													this.props.setModoTela(
														'exclusao',
														{
															...item
														}
													);

													this.props.initForm({
														...item
													});
												}}
											/>

										</Td>

									</Tr>
								);
							})}

						</TBody>

					</Table>

				</ContentCardBody>

			</ContentCard>
		);
	}


	montarExcel(lista) {

		const ExcelSheet =
			ReactExport.ExcelFile.ExcelSheet;

		const ExcelColumn =
			ReactExport.ExcelFile.ExcelColumn;


		return (
			<ExcelSheet
				data={
					lista.map(item => {

						const carga =
							this.cargaDaProducao(
								item.id
							);


						return {
							...item,

							data_agendamento:
								DateFormat
									.formatarDataSqlParaTela(
										item.data_agendamento
									),

							quantidade:
								parseFloat(
									FormatUtils
										.formatarValorBanco(
											item.quantidade,
											2
										)
								),

							id_carga:
								carga
									? carga.id
									: null,

							data_carga:
								carga
									? DateFormat
										.formatarDataSqlParaTela(
											carga.data_agendamento
										)
									: null,

							status_carga:
								carga
									? carga.status
									: null,

							nome_motorista_carga:
								carga
									? carga.nome_motorista
									: null,

							placa_veiculo_carga:
								carga
									? carga.placa_veiculo
									: null
						};
					})
				}
				name='Producões'
			>

				{[
					{
						componente:
							<ExcelColumn
								key={1}
								label='Ordem'
								value='ordem'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={2}
								label='Número'
								value='id'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={3}
								label='Solicitação'
								value='id_solicitacao'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={4}
								label='Agendamento'
								value='data_agendamento'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={5}
								label='Parceiro'
								value='nome_parceiro'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={6}
								label='Silo'
								value='solicitacao_silo'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={7}
								label='Lote'
								value='solicitacao_lote'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={8}
								label='Ração'
								value='nome_racao'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={9}
								label='Quantidade'
								value='capacidade'
								type='number'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={10}
								label='Unidade de Medida'
								value='sigla_unidade_medida'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={11}
								label='Carga'
								value='id_carga'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={12}
								label='Data da Carga'
								value='data_carga'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={13}
								label='Status da Carga'
								value='status_carga'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={14}
								label='Motorista da Carga'
								value='nome_motorista_carga'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={15}
								label='Veículo da Carga'
								value='placa_veiculo_carga'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={16}
								label='Usuário da Inclusão'
								value='nome_usuario_inclusao'
							/>
					},
					{
						componente:
							<ExcelColumn
								key={17}
								label='Usuário da Alteração'
								value='nome_usuario_alteproducao'
							/>
					}
				]
					.filter(item => true)
					.map(item =>
						item.componente
					)
				}

			</ExcelSheet>
		);
	}

}


const mapStateToProps = state => ({

	sessao:
		state.auth.usuario,

	modoTela:
		state.producao.modoTela,

	aguardando:
		state.producao.aguardando,

	filtro:
		state.producao.filtro,

	lista:
		state.producao.lista.filter(
			item =>
				!item.datahora_confirmacao
		),

	listaEquipamento:
		state.equipamento.listaSelect,

	listaCargas:
		state.carga.lista,

	aguardandoCarga:
		state.carga.aguardando,

	getPermissao:
		state.auth.getPermissao

});


const mapDispatchToProps = dispatch =>
	bindActionCreators({

		setModoTela,
		setFiltro,
		initForm,
		salvar,
		alterarOrdem,
		excluir,
		fecharDia,
		getLista,
		getListaSolicitacoes,

		getListaParceiro,
		getListaRacao,
		getListaUnidadeMedida,
		getListaEquipamento,
		getListaVeiculo,
		getListaMotorista,

		initCargaForm,
		salvarCarga,
		getListaCargas,
		getListaProducoesCarga

	}, dispatch);


export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Producao);